<template>
  <div class="AddStore addCommon" style="height: 100%">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{ titleType }}</span>
    </div>
    <div class="content">
      <el-button @click="submit('ruleForm')" type="primary" class="searchBtn" style="margin-left: 0;margin-bottom: 7px;" :loading="loadingSave">{{$t('LanguageLib.SAVE')}}</el-button>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ruleForm">
        <h4>{{$t('LanguageLib.BASIC_CONFIGURATION')}}</h4>
        <div class="contentInfo">
          <div class="infoForm">
            <div class="storePic parent" style="float: left;">
              <div class="parent" style="width: auto;">
                  <img v-if="ruleForm.storeThumbnail != '' && ruleForm.storeThumbnail != null" :src="ruleForm.storeThumbnail"/>
                  <img v-if="ruleForm.storeThumbnail == '' || ruleForm.storeThumbnail == null" src="@/assets/images/storeCover.png"/>
                  <p class="drawerText">{{$t('LanguageLib.SHOP_COVER')}}</p>
                </div>
                <div class="parent" style="margin-left: 10px;width: auto;">
                  <el-button size="small" type="primary">{{$t('LanguageLib.UPLOAD_COVER')}}</el-button>
                  <el-button size="small" type="primary" @click="deletePic">{{$t('LanguageLib.DELETE_COVER')}}</el-button>
                  <input ref="referenceUpload" type="file" id="uploads"
                    accept="image/png, image/jpeg, image/jpg, image/PNG, image/JPG, image/bmp"
                    @change="uploadImg($event, 1)">
                </div>
            </div>
            <div class="parent">
              <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.PARENT_ORGANIZATION')}}</p>
              <el-form-item prop="parentDomainId" style="position: relative">
                <el-input style="width: 320px;" class="TeInput" :readonly="true" v-model="ruleForm.parentDomainName">
                  <el-button @click="openOrgList" slot="append" :style="styleStr" icon="el-icon-more"></el-button>
                </el-input>
                <span v-if="ruleForm.parentDomainName.slice(0, 3) === 'wx|' && JSON.parse($commonfun.localStorage.getitem('qyuser'))" style="display: inline-block;width: 248px;height: 38px;position: absolute;left: 1px;top: 1px;border-radius: 5px;z-index: 9;">
                  <ww-open-data style="position: absolute;top: 1px;left: 14px;background: #fff;height: 36px;line-height: 36px;width: 232px;overflow: hidden;"  type="departmentName" :openid="ruleForm.parentDomainName.slice(3)"></ww-open-data>
                </span>
              </el-form-item>
            </div>
            <div class="parent" style="position: relative;">
              <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.STORE_NAME')}}</p>
              <el-form-item prop="storeName" style="white-space: nowrap;">
                <el-input style="width: 320px;" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.storeName" maxlength="50" @keyup.native="btKeyUp">
                </el-input>
                <span v-if="wxDepartmentId && JSON.parse($commonfun.localStorage.getitem('qyuser')) && showQyStoreName" style="cursor: no-drop;display: inline-block;width: 318px;height: 38px;position: absolute;left: 1px;top: 1px;background-color: #f5f7fa;border-radius: 5px;">
                  <ww-open-data style="position: absolute;top: 1px;left: 14px;background: #f5f7fa;height: 30px;width: 302px;overflow: hidden;" type="departmentName" :openid="wxDepartmentId"></ww-open-data>
                </span>
                <span v-if="wxDepartmentId && !JSON.parse($commonfun.localStorage.getitem('qyuser')) && showQyStoreName" style="cursor: no-drop;display: inline-block;width: 318px;height: 38px;position: absolute;left: 1px;top: 1px;background-color: #f5f7fa;border-radius: 5px;">
                  <span style="position: absolute;top: 1px;left: 14px;background: #f5f7fa;height: 30px;width: 302px;overflow: hidden;">wx|{{wxDepartmentId}}</span>
                </span>
                <div style="display: inline-block;position: absolute;height: 40px;">
                  <el-checkbox v-if="wxDepartmentId" v-model="showQyStoreName" style="margin-left: 10px;line-height: 20px;position: absolute;top: 0;">{{$t('LanguageLib.SHOW_QY_DEPARTMENTNAME')}}</el-checkbox>
                  <p v-if="$commonfun.localStorage.getitem('qyuser') === 'true' && wxDepartmentId" style="position: absolute;font-size: 12px;font-weight: 400;color: rgb(144, 147, 153);line-height: 20px;top: 20px;left: 10px;"><span>{{$t('LanguageLib.QY_DEPARTMENTNAME')}}:</span>&nbsp;&nbsp;<span v-html="$commonfun.RenderWxName('departmentName', 'wx|' + wxDepartmentId)">></span></p>
                  <p v-if="$commonfun.localStorage.getitem('qyuser') === 'false' && wxDepartmentId" style="position: absolute;font-size: 12px;font-weight: 400;color: rgb(144, 147, 153);line-height: 20px;top: 20px;left: 10px;"><span>{{$t('LanguageLib.QY_DEPARTMENTNAME')}}:</span>&nbsp;&nbsp;<span>{{$t('LanguageLib.QY_CANNOT_GET')}}</span></p>
                </div>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.SHOP_NUMBER')}}</p>
              <el-form-item prop="storeCode">
                <el-input style="width: 320px;" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.storeCode" maxlength="12">
                </el-input>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.SHOP_ENGLISH_NAME')}}</p>
              <el-input style="width: 320px;" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.storeAbbName" maxlength="50" @keyup.native="btKeyUp">
              </el-input>
            </div>
            <div class="parent">
              <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.z_info_common_000006')}}</p>
              <el-form-item prop="storeLang">
                <el-select style="width: 320px;" v-model="ruleForm.storeLang" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option v-for="item in langData" :key="item.typeCode" :label="item.typeDes" :value="item.typeValue">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">&nbsp;{{$t('LanguageLib.BRAND')}}</p>
              <el-form-item prop="brandInfoId">
                <el-select style="width: 320px;" filterable v-model="ruleForm.brandInfoId" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option v-for="item in brandList" :key="item.id" :label="item.brandNameCn" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.z_info_common_000007')}}</p>
              <el-form-item prop="currencyId">
                <el-select style="width: 320px;" filterable v-model="ruleForm.currencyId" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option v-for="item in currencyList" :key="item.id" :label="item.currencyCode" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.InfoStoreStatus')}}</p>
              <el-form-item prop="isClose">
                <el-select style="width: 320px;" v-model="ruleForm.isClose" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option :value=false :label="$t('LanguageLib.z_info_common_000087')">
                  </el-option>
                  <el-option :value=true :label="$t('LanguageLib.z_info_common_000069')">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.SHOP_TYPE')}}</p>
              <el-form-item>
                <el-select style="width: 320px;" v-model="ruleForm.storeTypeId" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option v-for="item in storeTypeList" :key="item.id" :label="item.typeName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.MODE_OF_OPERATION')}}</p>
              <el-form-item>
                <el-select style="width: 320px;" v-model.number="ruleForm.manageType" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option v-for="item in manageTypeList" :key="item.typeValue" :label="item.typeDes" :value="item.typeValue">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.AREA')}}</p>
              <el-form-item style="position: relative">
                <el-input style="width: 320px;" class="TeInput" :readonly="true" v-model="ruleForm.districtName">
                  <el-button @click="openOrgListRegion" class="openOrgList" slot="append" :style="styleStrRegion" icon="el-icon-more"></el-button>
                </el-input>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.BUSINESS_HOURS')}}</p>
              <el-form-item>
                <el-time-picker is-range v-model="dataTime" :range-separator="$t('LanguageLib.TO1')" :start-placeholder="$t('LanguageLib.STARTING_TIME')" :end-placeholder="$t('LanguageLib.END_TIME1')" :placeholder="$t('LanguageLib.InfoSelectTimeRange')" value-format="HH:mm:ss">
                </el-time-picker>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.DEALER_CORPORATE')}}</p>
              <el-form-item>
                <el-select style="width: 320px;" v-model="ruleForm.dealerId" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                  <el-option v-for="item in dealerList" :key="item.id" :label="item.dealerName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.SHOP_ADRESS')}}</p>
              <el-form-item>
                <el-input style="width: 320px;" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.storeAddress" maxlength="50">
                </el-input>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.SHOP_MAILBOX')}}</p>
              <el-form-item prop="storeEmail">
                <el-input style="width: 320px;" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.storeEmail" maxlength="50">
                </el-input>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.STORE_PHONE')}}</p>
              <el-form-item>
                <el-input style="width: 320px;" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.storePhone" maxlength="50">
                </el-input>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.STORE_CONTACT')}}</p>
              <el-form-item>
                <el-input style="width: 320px;" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.contact" maxlength="50">
                </el-input>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.CONTACT_NUMBER1')}}</p>
              <el-form-item>
                <el-input style="width: 320px;" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.contactPhone" maxlength="50">
                </el-input>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.STORE_INFO_OPENDATE')}}</p>
              <el-form-item>
                <el-date-picker value-format="yyyy-MM-dd" style="width: 320px;" v-model="ruleForm.openDate" type="date" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.STORE_INFO_CLOSEDATE')}}</p>
              <el-form-item>
                <el-date-picker value-format="yyyy-MM-dd" style="width: 320px;" v-model="ruleForm.closeDate" type="date" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.STORE_INFO_DECORATIONDATE')}}</p>
              <el-form-item>
                <el-date-picker value-format="yyyy-MM-dd" style="width: 320px;" v-model="ruleForm.decorationDate" type="date" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="parent">
              <p class="drawerText">{{$t('LanguageLib.STORE_INFO_AREASQUARE')}}</p>
              <el-form-item>
                <el-input-number style="width: 320px;" v-model="ruleForm.areaSquare" :min="0" :precision="2" :step="1" :max="2147483647"></el-input-number>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <!--上级组织-->
    <el-dialog :title="$t('LanguageLib.SelectOrganization')" :visible.sync="dialogTableVisible" width="360px !important">
      <DomainTree @addcheck-treedata="getTreeCheckData" :orgData="orgData" :orgTreeData="orgTreeData" :oneNodeArr="oneNodeArr"></DomainTree>
      <el-button style="float:right;margin-top:15px;" @click="keepOrgData" type="primary" class="searchBtn">{{$t('LanguageLib.DETERMINE')}}</el-button>
    </el-dialog>
    <!--地区-->
    <el-dialog :title="$t('LanguageLib.SelectOrganization')" :visible.sync="dialogTableVisibleRegion" width="360px !important">
      <DistrictTree @addcheck-treedata="getTreeCheckDataRegion" :districtData="districtData" :districtTreeData="districtTreeData" :twoNodeArr="twoNodeArr"></DistrictTree>
      <el-button style="float:right;margin-top:15px;" @click="keepOrgDataRegion" type="primary" class="searchBtn">{{$t('LanguageLib.DETERMINE')}}</el-button>
    </el-dialog>
    <el-dialog :title="$t('LanguageLib.PICTURE_CAPTURE')" :visible.sync="cropImageDialog" class="cropImageForm dialogStoreComm" :close-on-click-modal="false">
      <div class="cropper-content">
        <div class="cropper">
          <vueCropper
            ref="cropper"
            :centerBox="true"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="true"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixedBox="option.fixedBox"
            :fixedNumber="[1,1]"
            :fixed="true"
            @realTime="realTime"
            @imgLoad="imgLoad">
          </vueCropper>
        </div>
        <!--<div class="show-preview" :style="{'width': previews.w + 'px', 'height': previews.h + 'px','overflow': 'hidden', 'margin': '5px'}">
          <div :style="previews.div" class="preview">
            <img :src="previews.url" :style="previews.img"></div>
        </div>-->
      </div>
      <div class="footer-btn">
        <div class="scope-btn">
          <div class="buttonSlot" @click="changeScale(1)" :title="$t('LanguageLib.ENLARGE')">
            <div class="buttonContent"><i class="iconfont">&#xe607;</i></div>
            <div class="buttonContent text">{{$t('LanguageLib.ENLARGE')}}</div>
          </div>
          <div class="buttonSlot" @click="changeScale(-1)" :title="$t('LanguageLib.NARROW')">
            <div class="buttonContent"><i class="iconfont">&#xe608;</i></div>
            <div class="buttonContent text">{{$t('LanguageLib.NARROW')}}</div>
          </div>
          <div class="buttonSlot" @click="rotateLeft" :title="$t('LanguageLib.TURN_LEFT')">
            <div class="buttonContent"><i class="iconfont">&#xe605;</i></div>
            <div class="buttonContent text">{{$t('LanguageLib.TURN_LEFT')}}</div>
          </div>
          <div class="buttonSlot" @click="rotateRight" :title="$t('LanguageLib.TURN_RIGHT')">
            <div class="buttonContent"><i class="iconfont">&#xe609;</i></div>
            <div class="buttonContent text">{{$t('LanguageLib.TURN_RIGHT')}}</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="isLoading" style="margin-left:20px" type="primary" :style="'margin-left: 46px'" @click="down('base64')">{{$t('LanguageLib.DETERMINE')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import storeinformationApi from '../../api/storeinformation'
import DomainTree from '@/components/DomainTree.vue'
import DistrictTree from '@/components/regionTree.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
export default {
  name: 'AddStore',
  components: { DomainTree, DistrictTree, VueCropper },
  props: ['currentPage', 'pageSize', 'parentId', 'searchText', 'sort', 'sortOrder', 'checkedStoreTypeData', 'checkedModeOperationData', 'checkedBrandData', 'orgName', 'type', 'sortNumber', 'orgTypeid', 'remark'],
  data () {
    var checkStoreCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.SHOP_NUMBER') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.SHOP_NUMBER') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    var checkStoreName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.STORE_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.STORE_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    var checkLang = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        return callback(new Error(this.$t('LanguageLib.z_info_common_000006') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        callback()
      }
    }
    // var checkbrandInfo = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error(this.$t('LanguageLib.BRAND') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
    //   } else {
    //     callback()
    //   }
    // }
    var checkCurrencyId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.z_info_common_000007') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        callback()
      }
    }
    var checkIsClose = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        return callback(new Error(this.$t('LanguageLib.InfoStoreStatus') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        callback()
      }
    }
    var checkManageType = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        return callback(new Error(this.$t('LanguageLib.MODE_OF_OPERATION') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        callback()
      }
    }
    var checkParentOrg = (rule, value, callback) => {
      if (!value) {
        this.styleStr = 'width: 70px;height:40px;border-bottom: 1px solid #F56C6C;border-top: 1px solid #F56C6C;border-right: 1px solid #F56C6C;border-radius: 0 4px 4px 0;background-color: #D8DCE6;'
        return callback(new Error(this.$t('LanguageLib.PARENT_ORGANIZATION') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        this.styleStr = 'width: 70px;height:40px;border-bottom: 1px solid #dcdfe6;border-top: 1px solid #dcdfe6;border-right: 1px solid #dcdfe6;border-radius: 0 4px 4px 0;background-color: #D8DCE6;'
        callback()
      }
    }
    var checkStoreEmail = (rule, value, callback) => {
      this.$commonfun.console.log(value)
      if (value !== '' && value !== null) {
        if (value.indexOf('@') === -1) {
          return callback(new Error(this.$t('LanguageLib.InfoMustContain')))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      showQyStoreName: false, // 是否显示企微部门名称
      wxDepartmentId: '', // 企微部门id
      dataTime: ['08:30:00', '22:00:00'], // 营业时间
      langData: [], // 店铺多语言list
      brandList: [], // 所属品牌List
      currencyList: [], // 店铺货币List
      storeTypeList: [], // 店铺类型List
      manageTypeList: [], // 经营方式List
      dealerList: [], // 经销商List
      addparentName: '', // 上级组织名称
      fromQy: '', // 是否企微同步
      ruleForm: {
        id: null, // 店铺Id
        parentDomainId: null, // 上级组织Id
        parentDomainName: '', // 上级组织Name
        storeCode: '', // 店铺编号
        storeName: '', // 店铺名称
        storeAbbName: '', // 店铺英文名称
        storeAddress: '', // 店铺地址
        storePhone: '', // 店铺电话
        contact: '', // 联系人
        contactPhone: '', // 联系人电话
        areaSquare: '', // 面积
        openDate: '', // 开店时间
        closeDate: '', // 闭店时间
        decorationDate: '', // 最近装修时间
        storeEmail: '', // 店铺邮箱
        storeLang: '', // 店铺语言
        brandInfoId: '', // 所属品牌Id
        currencyId: null, // 默认货币Id
        isClose: false, // 店铺状态 默认正常
        storeTypeId: null, // 店铺类型Id
        manageType: '', // 经营方式（0:无 1:直营 2:经销）
        dealerId: null, // 经销商Id
        storeStartTime: '', // 开始时间
        storeEndTime: '', // 结束时间
        districtId: null, // 地区Id
        districtName: '', // 地区名称
        storeThumbnail: '' // 店铺头像
      },
      titleType: this.$t('LanguageLib.STORE_INFORMATION'),
      styleStr: 'width: 70px;height:40px;border-bottom: 1px solid #dcdfe6;border-top: 1px solid #dcdfe6;border-right: 1px solid #dcdfe6;border-radius: 0 4px 4px 0;background-color: #D8DCE6;',
      styleStrRegion: 'width: 70px;height:40px;border-bottom: 1px solid #dcdfe6;border-top: 1px solid #dcdfe6;border-right: 1px solid #dcdfe6;border-radius: 0 4px 4px 0;background-color: #D8DCE6;',
      dialogTableVisible: false, // 组织树视图的显示和隐藏
      dialogTableVisibleRegion: false, // 地区组织树试图的显示隐藏
      filterText: '', // 过滤文本
      showStatusTitle: this.$t('LanguageLib.COLLAPSE'),
      showStatus: false, // 组织树默认收起
      searchTreeIds: [], // 通过接口获取企微id
      defaultProps: {
        children: 'childDomainTrees',
        label: 'domainName'
      },
      OrgTypeList: [],
      addremark: '',
      orgData: [], // 上级组织
      districtData: [], // 地区
      orgTreeData: [], // 上级组织
      districtTreeData: [], // 地区
      oneNodeArr: [], // 上级组织
      twoNodeArr: [], // 地区
      addCheckparentName: '', // 上级组织
      addCheckparentId: '', // 上级组织
      addCheckDomainNo: '', // 上级组织
      editDomainNo: '',
      addCheckparentNameRegion: '', // 地区
      addCheckparentIdRegion: '', // 地区
      addCheckDomainNoRegion: '', // 地区
      rules: {
        storeCode: [{
          validator: checkStoreCode,
          trigger: 'blur'
        }],
        storeName: [{
          validator: checkStoreName,
          trigger: 'blur'
        }],
        storeLang: [{
          validator: checkLang,
          trigger: 'change'
        }],
        // brandInfoId: [{
        //   validator: checkbrandInfo,
        //   trigger: 'change'
        // }],
        currencyId: [{
          validator: checkCurrencyId,
          trigger: 'change'
        }],
        isClose: [{
          validator: checkIsClose,
          trigger: 'change'
        }],
        manageType: [{
          validator: checkManageType,
          trigger: 'blur'
        }],
        parentDomainId: [{
          validator: checkParentOrg,
          trigger: 'blur'
        }],
        storeEmail: [{
          validator: checkStoreEmail,
          trigger: 'blur'
        }]
      },
      cropImageDialog: false,
      crap: false,
      previews: {},
      option: {
        img: '',
        size: 1,
        full: false,
        outputType: 'png',
        canMove: true,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        autoCropWidth: 200,
        autoCropHeight: 200,
        fixedBox: true,
        fixedNumber: [1, 1]
      },
      downImg: '#',
      isLoading: false,
      loadingSave: false // 保存按钮加loding
    }
  },
  beforeRouteEnter (to, from, next) {
    NProgress.configure({
      easing: 'ease',
      speed: 500,
      showSpinner: false,
      trickleSpeed: 200,
      minimum: 0.3
    })
    NProgress.start()
    if (to.query.type === 'edit') {
      storeinformationApi.getstoreDetail('get', '/store/detail',
        {
          id: to.query.id
        })
        .then(res => {
          NProgress.done()
          next(vm => {
            vm.ruleForm.id = to.query.id
            vm.ruleForm.parentDomainName = res.data.parentDomainName
            vm.ruleForm.parentDomainId = res.data.parentDomainId
            vm.ruleForm.storeCode = res.data.storeCode
            if (res.data.storeName) {
              res.data.storeName.indexOf('wx|') >= 0 ? vm.showQyStoreName = true : vm.showQyStoreName = false
              vm.ruleForm.storeName = res.data.storeName.replace('wx|', '')
            } else {
              vm.ruleForm.storeName = res.data.storeName
            }
            vm.ruleForm.storeAbbName = res.data.storeAbbName
            vm.ruleForm.isClose = res.data.isClose
            vm.ruleForm.districtId = res.data.districtId
            vm.ruleForm.districtName = res.data.districtName
            vm.ruleForm.storeStartTime = res.data.storeStartTime === null ? '' : res.data.storeStartTime
            vm.ruleForm.storeEndTime = res.data.storeEndTime === null ? '' : res.data.storeEndTime
            vm.dataTime = [vm.ruleForm.storeStartTime, vm.ruleForm.storeEndTime]
            vm.ruleForm.storeAddress = res.data.storeAddress
            vm.ruleForm.storeEmail = res.data.storeEmail
            vm.ruleForm.storePhone = res.data.storePhone
            vm.ruleForm.contact = res.data.contact
            vm.ruleForm.contactPhone = res.data.contactPhone
            vm.ruleForm.openDate = res.data.openDate
            vm.ruleForm.closeDate = res.data.closeDate
            vm.ruleForm.areaSquare = res.data.areaSquare
            vm.ruleForm.decorationDate = res.data.decorationDate
            vm.editDomainNo = res.data.domainNo
            vm.fromQy = res.data.fromQy
            vm.ruleForm.storeThumbnail = res.data.storeThumbnail
            vm.wxDepartmentId = res.data.wxDepartmentId
            // 获取店铺多语言
            storeinformationApi.getLang('get', '/BasicData/GetLang', {
              pageIndex: 1,
              pageSize: 2147483647
            })
              .then(value => {
                vm.langData = value.data
                vm.ruleForm.storeLang = res.data.storeLang
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
            // 获取店铺所属品牌
            storeinformationApi.GetBrandInfo('get', '/store/GetBrandInfo', {
              pageIndex: 1,
              pageSize: 2147483647
            })
              .then(value => {
                vm.brandList = value.data
                vm.ruleForm.brandInfoId = res.data.brandInfoId
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
            // 获取默认货币
            storeinformationApi.GetEnableCurrency('get', '/Currency/GetEnable', {
              pageIndex: 1,
              pageSize: 2147483647
            })
              .then(value => {
                vm.currencyList = value.data
                vm.ruleForm.currencyId = res.data.currencyId
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
              // 获取店铺类型
            storeinformationApi.GetStoreType('get', '/store/GetStoreType', {
              pageIndex: 1,
              pageSize: 2147483647
            })
              .then(value => {
                vm.storeTypeList = value.data
                vm.ruleForm.storeTypeId = res.data.storeTypeId
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
            // 获取经营方式
            storeinformationApi.GetManageType('get', '/store/GetManageType', {
              pageIndex: 1,
              pageSize: 2147483647
            })
              .then(value => {
                vm.manageTypeList = value.data
                vm.ruleForm.manageType = res.data.manageType === 0 ? '' : res.data.manageType
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
            // 获取经销商
            storeinformationApi.GetDealerInfo('get', '/store/GetDealerInfo', {
              pageIndex: 1,
              pageSize: 2147483647
            })
              .then(value => {
                vm.dealerList = value.data
                vm.ruleForm.dealerId = res.data.dealerId
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
          })
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    } else {
      // 获取店铺多语言
      storeinformationApi.getLang('get', '/BasicData/GetLang', {
        pageIndex: 1,
        pageSize: 2147483647
      })
        .then(value => {
          NProgress.done()
          next(vm => {
            var date = new Date()
            var year = date.getFullYear().toString().substr(2, 2)
            var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
            var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
            var hour = date.getHours()
            var minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
            var second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
            var time = year + month + day + hour + minute + second
            vm.ruleForm.storeCode = time
            vm.langData = value.data
            // 获取店铺所属品牌
            storeinformationApi.GetBrandInfo('get', '/store/GetBrandInfo', {
              pageIndex: 1,
              pageSize: 2147483647
            })
              .then(value => {
                vm.brandList = value.data
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
            // 获取默认货币
            storeinformationApi.GetEnableCurrency('get', '/Currency/GetEnable', {
              pageIndex: 1,
              pageSize: 2147483647
            })
              .then(value => {
                vm.currencyList = value.data
                // 公司的默认语言
                var OwnerLanguage = vm.$commonfun.localStorage.getitem('OwnerLanguage') * 1
                var currencyCode = ''
                switch (OwnerLanguage) {
                  case 0:
                    currencyCode = 'RMB'
                    break
                  case 1:
                    currencyCode = 'HKD'
                    break
                  case 2:
                    currencyCode = 'USD'
                    break
                  case 3:
                    currencyCode = 'JPY'
                    break
                  case 4:
                    currencyCode = 'KRW'
                    break
                }
                for (var i in value.data) {
                  var item = value.data[i]
                  if (item.currencyCode === currencyCode) {
                    vm.ruleForm.currencyId = item.id
                  }
                }
                vm.ruleForm.storeLang = OwnerLanguage
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
              // 获取店铺类型
            storeinformationApi.GetStoreType('get', '/store/GetStoreType', {
              pageIndex: 1,
              pageSize: 2147483647
            })
              .then(value => {
                vm.storeTypeList = value.data
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
            // 获取经营方式
            storeinformationApi.GetManageType('get', '/store/GetManageType', {
              pageIndex: 1,
              pageSize: 2147483647
            })
              .then(value => {
                vm.manageTypeList = value.data
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
            // 获取经销商
            storeinformationApi.GetDealerInfo('get', '/store/GetDealerInfo', {
              pageIndex: 1,
              pageSize: 2147483647
            })
              .then(value => {
                vm.dealerList = value.data
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
          })
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    }
  },
  created () {
    // 获取组织树列表
    storeinformationApi.gettreelist('get', '/sysdomain/domainTree')
      .then(res => {
        this.orgData = res.data
        this.orgTreeData = this.$commonfun.toTree(res.data, 'childDomainTrees', 'id', 'parentDomainId')
        this.oneNodeArr.push(this.orgTreeData[0].id)
        if (this.$route.query.type === 'add') {
          for (let i = 0; i < this.orgData.length; i++) {
            if (this.orgData[i].id === this.$route.query.checkDomainId) {
              this.addparentName = this.orgData[i].domainName
              this.ruleForm.parentDomainId = this.$route.query.checkDomainId
              this.ruleForm.parentDomainName = this.orgData[i].domainName
            }
          }
        }
      })
      .catch(err => {
        this.$commonfun.console.log(err)
      })
      // 获取公司地区列表
    storeinformationApi.GetDistrict('get', '/basicdata/GetDistrict')
      .then(res => {
        this.districtData = res.data
        this.districtTreeData = this.$commonfun.toRegionTree(res.data, 'childDomainTrees', 'id', 'parentId')
        this.twoNodeArr.push(this.districtTreeData[0].id)
      })
      .catch(err => {
        this.$commonfun.console.log(err)
      })
  },
  methods: {
    // 放大/缩小
    changeScale (num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    // 左旋转
    rotateLeft () {
      this.$refs.cropper.rotateLeft()
    },
    // 右旋转
    rotateRight () {
      this.$refs.cropper.rotateRight()
    },
    finish (type) {
      // 输出
      // var test = window.open('about:blank')
      // test.document.body.innerHTML = '图片生成中..'
      if (type === 'blob') {
        this.$refs.cropper.getCropBlob(data => {
          var img = window.URL.createObjectURL(data)
          this.model = true
          this.modelSrc = img
        })
      } else {
        this.$refs.cropper.getCropData(data => {
          this.model = true
          this.modelSrc = data
        })
      }
    },
    // 实时预览函数
    realTime (data) {
      this.previews = data
    },
    // 图片转blob
    convertBase64UrlToBlob (urlData) {
      const bytes = window.atob(urlData.split(',')[1]) // 去掉url的头，并转换为byte
      // 处理异常,将ascii码小于0的转换为大于0
      const ab = new ArrayBuffer(bytes.length)
      const ia = new Uint8Array(ab)
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i)
      }
      return new Blob([ab], {
        type: 'image/jpg'
      })
    },
    // 截取上传
    down (type) {
      // event.preventDefault()
      if (!this.option.img) {
        this.$message.success(this.$t('LanguageLib.PLEASE_SELECT_A_PICTURE'))
        return
      }
      this.isLoading = true
      var aLink = document.createElement('a')
      aLink.download = 'author-img'
      // 输出
      if (type === 'blob') {
        this.$refs.cropper.getCropBlob(data => {
          this.downImg = window.URL.createObjectURL(data)
          aLink.href = window.URL.createObjectURL(data)
          aLink.click()
        })
      } else {
        this.$refs.cropper.getCropData(data => {
          this.downImg = data
          const that = this
          var canvas = document.createElement('canvas')
          canvas.width = 640
          canvas.height = 640
          var ctx = canvas.getContext('2d')
          // 创建img
          var image = new Image()
          image.src = data
          var dataNew, blob
          image.onload = function () {
            ctx.drawImage(image, 0, 0, 640, 640)
            dataNew = canvas.toDataURL()
            blob = that.convertBase64UrlToBlob(dataNew)
            const formData = new FormData()
            blob.name = 'cover.jpg'
            formData.append('file', blob, blob.name)
            formData.append('path', 'images')
            storeinformationApi.uploadImg('post', '/api/FileUpload', formData, 'webUrl')
              .then(res => {
                that.cropImageDialog = false
                that.isLoading = false
                that.ruleForm.storeThumbnail = res.data[0]
              })
              .catch(err => {
                this.$commonfun.console.log(err)
                that.isLoading = false
              })
          }
        })
      }
    },
    // 上传图片
    uploadImg (e, num) {
      // 上传图片
      // this.option.img
      this.$commonfun.console.log(e.target.result)
      var file = e.target.files[0]
      if (!/\.(jpg|jpeg|png|bmp|JPG|PNG)$/.test(e.target.value)) {
        this.$message.success(this.$t('LanguageLib.PLEASE_SELECT_CORRECT_PICTURE_FORMAT'))
        return false
      }
      var reader = new FileReader()
      reader.onload = e => {
        let data
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }
        if (num === 1) {
          this.cropImageDialog = true
          this.$refs.referenceUpload.value = null
          this.option.img = data
        } else if (num === 2) {
          this.example2.img = data
        }
      }
      // 转化为base64
      reader.readAsDataURL(file)
      // 转化为blob
      // reader.readAsArrayBuffer(file)
    },
    imgLoad (msg) {
    },
    // 删除封面
    deletePic () {
      this.ruleForm.storeThumbnail = ''
    },
    // 去除组织名称的特殊字符
    btKeyUp (e) {
      e.target.value = e.target.value.replace(/[\\/:：*?？"<>|]/g, '')
    },
    // 返回
    goReturn () {
      this.$router.push('/storeinformation/storemanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&checkDomainId=' + this.$route.query.checkDomainId + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&sortOrder=' + this.$route.query.sortOrder + '&checkedStoreTypeData=' + this.$route.query.checkedStoreTypeData + '&checkedModeOperationData=' + this.$route.query.checkedModeOperationData + '&checkedBrandData=' + this.$route.query.checkedBrandData + '&fromPath=addstore')
    },
    // 打开上级组织组织树视图
    openOrgList () {
      this.dialogTableVisible = true
    },
    // 打开地区组织树视图
    openOrgListRegion () {
      this.dialogTableVisibleRegion = true
    },
    // 树组件传过来的数据-上级组织
    getTreeCheckData (data) {
      this.addCheckparentName = data.domainName
      this.addCheckparentId = data.id
      this.addCheckDomainNo = data.domainNo
    },
    // 树组件传过来的数据-地区
    getTreeCheckDataRegion (data) {
      this.$commonfun.console.log(data)
      this.addCheckparentNameRegion = data.districtName
      this.addCheckparentIdRegion = data.id
      this.addCheckDomainNoRegion = data.districtCode
    },
    // 保存树数据-上级组织
    keepOrgData () {
      // if (this.$route.query.type === 'add') {
      //   this.dialogTableVisible = false
      //   this.addparentName = this.addCheckparentName
      //   this.ruleForm.parentDomainId = this.addCheckparentId
      // } else {
      //   if (this.addCheckDomainNo.slice(0, this.editDomainNo.length) !== this.editDomainNo) {
      //     this.dialogTableVisible = false
      //     this.addparentName = this.addCheckparentName
      //     this.ruleForm.parentDomainId = this.addCheckparentId
      //   } else {
      //     this.$message({
      //       type: 'warning',
      //       message: this.$t('LanguageLib.NoSelectMsg1')
      //     })
      //   }
      // }
      this.dialogTableVisible = false
      this.ruleForm.parentDomainName = this.addCheckparentName
      this.ruleForm.parentDomainId = this.addCheckparentId
    },
    // 保存树数据-地区
    keepOrgDataRegion () {
      this.dialogTableVisibleRegion = false
      this.ruleForm.districtName = this.addCheckparentNameRegion
      this.ruleForm.districtId = this.addCheckparentIdRegion
    },
    // 保存数据
    submit (formName) {
      if (this.showQyStoreName && this.wxDepartmentId) {
        this.ruleForm.storeName = 'wx|' + this.wxDepartmentId
      } else {
        if (this.ruleForm.storeName) {
          this.ruleForm.storeName = this.ruleForm.storeName.replace(/[\\/:：*?？"<>|]/g, '')
        } else {
          this.ruleForm.storeName = ''
        }
      }
      if (this.ruleForm.storeAbbName) {
        this.ruleForm.storeAbbName = this.ruleForm.storeAbbName.replace(/[\\/:：*?？"<>|]/g, '')
      } else {
        this.ruleForm.storeAbbName = ''
      }
      this.ruleForm.brandInfoId = this.ruleForm.brandInfoId === '' ? null : this.ruleForm.brandInfoId
      if (this.ruleForm.manageType === '') {
        this.ruleForm.manageType = 0
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dataTime !== '') {
            this.ruleForm.storeStartTime = this.dataTime[0]
            this.ruleForm.storeEndTime = this.dataTime[1]
          }
          this.loadingSave = true
          if (this.$route.query.type === 'add') {
            delete this.ruleForm.id
            storeinformationApi.AddStore('post', '/store/create', this.ruleForm)
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.ADDED_SUCCESSFULLY1')
                })
                this.ruleForm.manageType = ''
                this.$router.push('/storeinformation/storemanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&checkDomainId=' + this.$route.query.checkDomainId + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&sortOrder=' + this.$route.query.sortOrder + '&checkedStoreTypeData=' + this.$route.query.checkedStoreTypeData + '&checkedModeOperationData=' + this.$route.query.checkedModeOperationData + '&checkedBrandData=' + this.$route.query.checkedBrandData + '&fromPath=addstore')
                this.loadingSave = false
              })
              .catch(err => {
                this.loadingSave = false
                this.ruleForm.manageType = ''
                this.$commonfun.console.log(err)
              })
          } else {
            storeinformationApi.editStore('post', '/store/Update', this.ruleForm)
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.EditSuccess')
                })
                this.ruleForm.manageType = ''
                this.$router.push('/storeinformation/storemanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&checkDomainId=' + this.$route.query.checkDomainId + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&sortOrder=' + this.$route.query.sortOrder + '&checkedStoreTypeData=' + this.$route.query.checkedStoreTypeData + '&checkedModeOperationData=' + this.$route.query.checkedModeOperationData + '&checkedBrandData=' + this.$route.query.checkedBrandData + '&fromPath=addstore')
                this.loadingSave = false
              })
              .catch(err => {
                this.loadingSave = false
                this.ruleForm.manageType = ''
                this.$commonfun.console.log(err)
              })
          }
        } else {
          return false
        }
      })
    }
  },
  watch: {
    showQyStoreName (value) {
      if (value) {
        this.ruleForm.storeName = this.wxDepartmentId + ''
      }
    }
  }
}
</script>

<style lang="scss">
  .AddStore {
    .TeInput input {
      border-right: 0px;
      border-radius: 4px 0 0 4px;
    }
    .buttonSlot {
      padding: 0 4px;
      color: white;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border-radius: 5%;
      cursor: pointer;
      width: 98px;
      margin: 0 1px;
      text-overflow: ellipsis;
      overflow: hidden;
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      height: 30px;
      margin-bottom: 15px;

      .buttonContent {
        display: inline-block;
        margin-right: 3px;
      }

      .buttonContent.text {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .return {
      padding-left: 25px;
      position: relative;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      line-height: 50px;
      border-bottom: 1px solid #F2F2F2;
      .el-icon-back {
        margin-right: 15px;
        cursor: pointer;
      }
      .border {
        position: absolute;
        height: 37px;
        border-left: 1px solid #f1f1f1;
        display: inline-block;
        top: 5px;
      }
      .title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-left: 15px;
      }
    }
    .content::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    .content::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }
    .content::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: #fff;
    }
    .content {
      background: rgba(255, 255, 255, 1);
      width: 100%;
      height: calc( 100% - 66px);
      overflow-y: auto;
      padding: 0 100px;
      padding-top: 15px;
      box-sizing: border-box;
      .drawerText {
        margin-bottom: 5px;
        height: 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(77, 77, 77, 1);
        line-height: 16px;
      }
      h4 {
        font-size: 16px;
        color: #000;
        font-weight: normal;
        padding-top: 8px;
      }
      .contentTop,
      .infoForm {
        padding: 15px 0 0 26px;
        .parent {
          width: 50%;
          display: inline-block;
        }
      }
      .storePic{
        overflow: hidden;
        .parent{
          float: left;
          width: auto;
          position: relative;
          margin-bottom: 16px;
          img{
            width: 100px;
            height: 100px;
            border-radius: 50%;
            border: 1px solid #E1E1E1;
          }
          .drawerText{
            width: 100px;
            text-align: center;
            margin-top: 4px;
          }
          input{
            position: absolute;
            left: 10px;
            width: calc(100% - 10px);
            height: 30px;
            top: 0;
            opacity: 0;
          }
          .el-button--primary{
            display: inherit;
            margin-bottom: 8px;
            font-size: 14px;
          }
          .el-button--primary:nth-of-type(2){
            background: #fff;
            color: #C0C4CC;
            border:1px solid rgba(216,220,230,1);
          }
        }
      }
    }
     /*修改按钮样式*/
    .el-button--primary {
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      height: 30px;
      padding: 7px 20px;
      margin-bottom: 15px;
    }
    .colorRed {
      color: red;
    }
     /*组织树视图*/
    .el-dialog {
      overflow: hidden;
      .left {
        background: #fff;
        width: 320px;
        height: 535px;
        border: 1px solid #f2f2f2;
        .fifter {
          height: 30px;
          padding: 10px 0 10px 20px;
          margin: 0 auto;
          border-bottom: 1px solid #f2f2f2;
          .el-input {
            width: 220px;
            input {
              height: 30px;
              line-height: 30px;
              border-radius: 20px;
            }
            .el-icon-search {
              line-height: 30px;
            }
          }
          .el-button--text {
            margin-left: 8px;
            padding: 7px 0;
            color: #3BC6B9;
          }
        }
        .treeBox {
          height: calc( 100% - 51px);
          overflow: auto;
          width: 320px;
        }
        .treeBox::-webkit-scrollbar {
          width: 10px;
          height: 10px;
        }
        .treeBox::-webkit-scrollbar-thumb {
          border-radius: 5px;
          -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
          background: #E1E1E1;
        }
        .treeBox::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
          border-radius: 5px;
          background: #fff;
        }
      }
    }
    .el-textarea__inner {
      font: 400 13.3333px Arial;
    }
  }
.el-range-editor.el-input__inner{
  width: 320px;
}
.cropper-content {
    background: #f2f2f2;
    padding-top: 20px;
    /*display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
    -webkit-justify-content: flex-end;*/
    .cropper {
      width: 400px;
      height: 400px;
      margin: 0 auto;
    }
    .show-preview {
      flex: 1;
      -webkit-flex: 1;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      -webkit-justify-content: center;
      .preview {
        overflow: hidden;
        border-radius: 50%;
        border: 1px solid #cccccc;
        background: #cccccc;
        margin-left: 40px;
      }
    }
  }
  .footer-btn {
    padding-top: 20px;
    background: #f2f2f2;
    /*display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
    -webkit-justify-content: flex-end;*/
    .scope-btn {
      width: 400px;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      margin: 0 auto;
      span{
        display: block;
        float: left;
      }
    }
    .upload-btn {
      flex: 1;
      -webkit-flex: 1;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      -webkit-justify-content: center;
    }
  }
  .label-success {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    font-weight: 500;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
    color: #fff;
    background-color: rgb(103, 194, 58) !important;
    border-color: rgb(103, 194, 58) !important;
  }
  .label-success:hover {
    background-color: rgb(133, 206, 97) !important;
    border-color: rgb(133, 206, 97) !important;
  }
  .dialogStoreComm{
    .el-dialog{
      width: 500px !important;
      height: 660px !important;
      .el-dialog__header{
        padding: 20px;
        border-bottom: 1px solid #EBEEF5;
      }
      .el-dialog__body{
        padding: 20px;
      }
    }
  }
</style>
